const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
    <style>

        .container {
            margin-top: 42px;
        }

        .item-container {
            display: flex;
            align-items: center;
            margin-bottom: 24px;
        }

        .item-container a {
            color: #424242;
            font-size: 18px;
            font-weight: 700;
            text-decoration: none;
            line-height: 24px;
        }

        .item-container a:hover, .item-container a:active {
            color: #3570D2;
        }

        .link-active-blue {
            color: #3570D2 !important;
            pointer-events: none;
            cursor: default;
        }
    </style>
</template>`;
styleElement.register("webinar-menu-option-style");